import { CallBackProps, EVENTS, STATUS } from "react-joyride";
import { CustomStep } from "./warehouseJoyrideSteps";
import { LOCAL_STORAGE_ACTIVE, LOCAL_STORAGE_START_PATH, LOCAL_STORAGE_STEP, LOCAL_STORAGE_TYPE } from "./constants";

export const handleWarehouseJoyrideCallback = (
    data: CallBackProps,
    setStepIndex: (i: number) => void,
    setRun: (b: boolean) => void,
    navigate: (path: string) => void,
    steps: CustomStep[]
) => {
    const { action, index, status, type, lifecycle } = data;

    if (lifecycle === "complete" || action === "next") {
        localStorage.setItem("joyrideStep", String(index + 1));
        setStepIndex(index + 1);
    }

    // Completion or exit
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
        const returnPath = localStorage.getItem(LOCAL_STORAGE_START_PATH);

        localStorage.setItem(LOCAL_STORAGE_ACTIVE, "false");
        localStorage.removeItem(LOCAL_STORAGE_STEP);
        localStorage.removeItem(LOCAL_STORAGE_TYPE);
        localStorage.removeItem(LOCAL_STORAGE_START_PATH);
        setRun(false);

        if (returnPath) {
            navigate(returnPath);
        }
        return;
    }

    // Go to next/previous step
    if (type === EVENTS.STEP_AFTER) {
        const nextStep = action === "next" ? index + 1 : action === "prev" ? index - 1 : index;

        if (nextStep < 0 || nextStep >= steps.length) {
            setRun(false);
            return;
        }

        const nextTarget = steps[nextStep]?.target;
        const nextRoute = steps[nextStep]?.route;

        // If the target is not found on the current page, we follow the route from the next step config
        if (nextTarget && !document.querySelector(nextTarget)) {
            if (nextRoute) {
                navigate(nextRoute);
                const observer = new MutationObserver(() => {
                    const element = document.querySelector(nextTarget);
                    if (element) {
                        observer.disconnect();

                        // if element is present — adjust scroll strategy (center only if element fits)
                        const rect = (element as HTMLElement).getBoundingClientRect();
                        const vh = window.innerHeight || document.documentElement.clientHeight;

                        if (rect.height <= vh) {
                            element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
                        } else {
                            if (rect.top < 0) {
                                window.scrollBy({ top: rect.top - 20, behavior: "auto" });
                            }
                        }

                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                setStepIndex(nextStep);
                                localStorage.setItem(LOCAL_STORAGE_STEP, String(nextStep));
                                window.dispatchEvent(new Event("resize"));
                            });
                        });
                    }
                });

                observer.observe(document.body, { childList: true, subtree: true });
                return;
            } else {
                console.error(`No route defined for step ${nextStep} with target ${nextTarget}`);
            }
        }

        setStepIndex(nextStep);
        localStorage.setItem(LOCAL_STORAGE_STEP, String(nextStep));
    }
};
